import type { ReactNode } from 'react';
import { Navigate } from '@tanstack/react-router';
import { useSession } from '../api/hooks';

export function AuthOnly({ stage, children }: { stage: 'login' | 'code' | 'setup'; children: ReactNode }) {
  const session = useSession();
  const data = session.data;
  if (data?.authenticated) return <Navigate to="/" replace />;
  if (stage !== 'login' && data && !data.authenticated && !data.stage)
    return <Navigate to="/login" replace />;
  if (stage === 'code' && data?.stage === 'setup') return <Navigate to="/login/setup" replace />;
  if (stage === 'setup' && data?.stage === 'password') return <Navigate to="/login/code" replace />;
  return <>{children}</>;
}
